// extracted by mini-css-extract-plugin
export default {"AdSlotOffsite":"bgi_a bhh_bi"};